import React, { useState, useEffect, useContext } from "react";
import {
  Container,
  TextField,
  Button,
  Card,
  CardContent,
  Typography,
  Alert,
  Box,
  Grid,
} from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import axios from "axios"; // Import axios for API requests
import { UserContext } from "../context/UserContext";
import API_BASE_URL from "../config";

const Support = () => {
  const { user } = useContext(UserContext); // Get user from UserContext

  console.log("User from context:", user); // Log user object

  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [success, setSuccess] = useState(false);

  // Fetch user data (email) based on userId from the API when user is available
  useEffect(() => {
    if (user && user.id) {
      // Use `id` from user context
      const fetchUserData = async () => {
        try {
          // Fetch user data using `id` instead of `user_id`
          const response = await axios.get(`${API_BASE_URL}/users/${user.id}`);
          setEmail(response.data.email); // Set the email from response
        } catch (error) {
          console.error("Error fetching user data:", error);
        }
      };
      fetchUserData();
    } else {
      console.log("User ID is missing");
    }
  }, [user]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!user || !user.id || !email || !message) {
      // Use `id` from user context
      alert("Please ensure all fields are filled out correctly.");
      return;
    }

    try {
      const response = await axios.post(`${API_BASE_URL}/support`, {
        user_id: user.id, // Use `id` here
        mail: email,
        message: message,
      });

      if (response.status === 201) {
        setSuccess(true);
        setMessage(""); // Reset message field
      }
    } catch (error) {
      console.error("Error submitting support ticket:", error);
      alert("An error occurred while submitting your request.");
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 5, mb: 3 }}>
      <Card sx={{ p: 3, boxShadow: 3 }}>
        <CardContent>
          <Typography
            variant="h5"
            fontWeight="bold"
            textAlign="center"
            sx={{ color: "#42326e" }}
          >
            Contact Support
          </Typography>

          {success && (
            <Alert severity="success" sx={{ mt: 2 }}>
              Your request has been submitted!
            </Alert>
          )}

          <form onSubmit={handleSubmit}>
            <Grid item xs={12} sx={{ mt: 4 }}>
              <Box display="flex" alignItems="center" gap={1}>
                <EmailIcon color="action" />
                <TextField
                  fullWidth
                  label="Email Address"
                  variant="outlined"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  disabled
                />
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box display="flex" alignItems="center" gap={1}>
                <ReportProblemIcon color="action" />
                <TextField
                  fullWidth
                  label="Describe Your Issue"
                  multiline
                  rows={2}
                  variant="outlined"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  required
                  sx={{ mt: 2 }}
                />
              </Box>
            </Grid>
            <Button
              variant="contained"
              fullWidth
              sx={{
                mt: 3,
                backgroundColor: "#42326e",
                color: "white",
                "&:hover": {
                  backgroundColor: "black",
                  color: "white",
                },
              }}
              type="submit"
            >
              Submit Request
            </Button>
          </form>
        </CardContent>
      </Card>
    </Container>
  );
};

export default Support;
